import { buildQuickview } from "@coveo/headless";
import React, { FunctionComponent, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import axios from 'axios';
import Modal from "../Button/Modal";

const DownloadInfo: FunctionComponent<any> = (props) => {
    const fileTypeMapping: any = {
        "DR": "drivers",
        "AP": "software",
        "UT": "utilities",
        "FA": "firmware"
    }
    const isShowRecommendedForModel = props.isShowRecommendedForModel;
    const [isViewDownloadInfo, setIsViewDownloadInfo] = useState(false);
    const [downloadInfoContent, setDownloadInfoContent] = useState('');
    const [isViewInstallGuide, setIsViewInstallGuide] = useState(false);
    const [installGuideContent, setInstallGuideContent] = useState(false);
    let [isLoadedDownloadInfo,setIsLoadedDownloadInfo] = useState(false);
    let [isLoadedInstallGuide,setIsLoadedInstallGuide] = useState(false);
    let [pathCategory,setPathCategory] = useState("");
    const handleViewDownloadInfo = ()=>{
        setIsViewDownloadInfo(true);
        getDownloadInfo();
    }
    const handleViewInstallGuide = ()=>{
        setIsViewInstallGuide(true);
        getInstallGuide();
    }
    const getDownloadInfo = async () => {
        let path = getPathCategory();
        if (path != pathCategory) {
            setPathCategory(path);
        }
        if (isLoadedDownloadInfo && path === pathCategory) {
            return;
        }
        try {
            let typeofFile = fileTypeMapping[props.item.inetfiletype];
            let language = props.item?.language ? props.item?.language[0] : "English";
            if( props.item?.recommended){
                typeofFile = 'downloadFiles'
            }
            let renditionUrl = "https://www.usa.canon.com/nw3s" + props.item.rendition_url;
            const response = await axios.get(window.location.origin + '/bin/canon/downloadFiles.modal.json', {
                params: {
                    'path': path,
                    'subtype': typeofFile,
                    'language': language,//language
                    'fileID': props.item.inetdoccid,//inetdoccid
                    'renditionUrl': renditionUrl //renditionUrl,
                }
            }).then((res)=>{
                setDownloadInfoContent(res.data.installation1 ?? 'There is no download info available, please try later');
                setIsLoadedDownloadInfo(true);
            });

        } catch (error) {
            console.error('Error fetching content:', error);
        }
    };
    const getInstallGuide = async () => {
        let path = getPathCategory();
        if (path != pathCategory) {
            setPathCategory(path);
        }
        if (isLoadedInstallGuide && path === pathCategory) {
            return;
        }
        let typeofFile = fileTypeMapping[props.item.inetfiletype];
        let language = props.item?.language ? props.item?.language[0] : "English";
        let renditionUrl = "https://www.usa.canon.com/nw3s" + props.item.rendition_url;
        if( props.item?.recommended){
            typeofFile = 'downloadFiles'
        }
        try {
            const response = await axios.get(window.location.origin + '/bin/canon/downloadFiles.modal.json', {
                params: {
                    'path': getPathCategory(),
                    'subtype': typeofFile,
                    'type': 'DS',
                    'language': language,//language
                    'fileID': props.item.inetdoccid,//inetdoccid
                    'renditionUrl': renditionUrl,
                }
            }).then((res)=>{
                let dataInstallation = res.data.installation1 ?? res.data.installation2;
                if (!dataInstallation) {
                    dataInstallation = 'There is no instruction info available, please try later';
                }
                setInstallGuideContent(dataInstallation.replaceAll("\r", "<br/>").replaceAll("break", "<br/>"));
                setIsLoadedInstallGuide(true);
            });

        } catch (error) {
            console.error('Error fetching content:', error);
        }
    };

    function getPathCategory () {
        let aemProductCategory = props.item?.aem_product_category ?? [];
        let path = "";
        if (aemProductCategory.length > 0) {
            let aemProductCategoryModel = aemProductCategory?.filter((item: any, index: number) => { return item.includes(isShowRecommendedForModel)}) ?? [];
            if (isShowRecommendedForModel && aemProductCategoryModel.length > 0) {
                path = aemProductCategoryModel[0].split(":")[1];
            } else {
                path = aemProductCategory[0].split(":")[1];
            }
        }
        return path;
    }

    return (
        <div className="ctaLinkInfo">
            <a className="cardDownloadInfo" onClick={handleViewDownloadInfo}>More Download Info </a>
            {isViewDownloadInfo && <Modal isNormal={true} stateChange={setIsViewDownloadInfo} visible={true} htmlContent={downloadInfoContent} headerContent={'Download Details'}></Modal>}
            <a className="cardInstallGuide" onClick={handleViewInstallGuide}>Installation&nbsp;Instruction</a>
            {isViewInstallGuide && <Modal isNormal={true} stateChange={setIsViewInstallGuide} visible={true} htmlContent={installGuideContent} headerContent={'How to Download and Install'}></Modal>}
        </div>
    )
};

export default DownloadInfo;
